import React from "react";
import InputText from "../InputText/InputText";
import Icon from "../Icon/Icon";
import classNames from "classnames";

export default class InputTextIcon extends React.PureComponent {
  render() {
    const { glyph, inputRef, iconProps = {}, position = "left", wrapperClassName, ...rest } = this.props;
    const inputClasses = classNames(
      "input-text-icon",
      `input-text-icon--${position}`,
      this.props.disabled && "disabled",
      wrapperClassName
    );

    return (
      <div className={ inputClasses }>
        { position === "left" && <Icon glyph={ glyph } { ...iconProps } className="input-text-icon__icon"/> }
        <InputText inputRef={ inputRef } { ...rest }/>
        { position === "right" && <Icon glyph={ glyph } { ...iconProps } className="input-text-icon__icon"/> }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/InputTextIcon/InputTextIcon.jsx